import {
  AUDIT_FETCHING,
  AUDIT_DONE,
  AUDIT_FAILED,
  AUDIT_MODAL_REGIONS_FETCHING,
  AUDIT_MODAL_REGIONS_DONE,
  AUDIT_MODAL_REGIONS_FAILED,
  AUDIT_MODAL_RULES_FETCHING,
  AUDIT_MODAL_RULES_DONE,
  AUDIT_MODAL_RULES_FAILED,
  AUDIT_MODAL_PARTNERS_FETCHING,
  AUDIT_MODAL_PARTNERS_DONE,
  AUDIT_MODAL_PARTNERS_FAILED,
  AUDIT_MODAL_RULESETS_FETCHING,
  AUDIT_MODAL_RULESETS_DONE,
  AUDIT_MODAL_RULESETS_FAILED,
  AUDIT_AMENDMENT_MODAL_RULES_FETCHING,
  AUDIT_AMENDMENT_MODAL_RULES_DONE,
  AUDIT_AMENDMENT_MODAL_RULES_FAILED,
  RULESET_CREATION_FAILED,
  RULESET_CREATION_SENDING,
  RULESET_CREATION_SUCCESS,
  RULESET_CREATION_RESET,
  AUDIT_FILE_SENDING,
  AUDIT_FILE_FAILED,
  AUDIT_FILE_SUCCESS,
  AUDIT_FILE_RESET,
  AUDIT_RULE_AMENDMENT_FAILED,
  AUDIT_RULE_AMENDMENT_SENDING,
  AUDIT_RULE_AMENDMENT_SUCCESS,
  AUDIT_RULE_AMENDMENT_RESET,
} from './actions'
import { APP_STATE } from '../../../constants'

export const initialState = {
  // Audit viewing
  auditListState: null,
  auditList: [],
  fetchError: '',
  pageTotal: null,
  page: null,

  // Audit modals
  auditModalRegionsState: null,
  auditModalRegionsData: [],
  auditModalRegionsError: null,
  auditModalRulesState: null,
  auditModalRulesData: [],
  auditModalRulesError: null,
  auditModalPartnersState: null,
  auditModalPartnersData: [],
  auditModalPartnersError: null,
  auditModalRulesetsState: null,
  auditModalRulesetsData: [],
  auditModalRulesetsError: null,
  auditModalAmendmentRulesState: null,
  auditModalAmendmentRulesData: [],
  auditModalAmendmentRulesError: null,

  rulesetCreationState: null,
  rulesetCreationResponse: null,

  auditRuleAmendmentState: null,
  auditRuleAmendmentResponse: null,

  auditFileState: null,
}

export const reducer = (state, action) => {
  switch (action.type) {
    // Audit viewing
    case AUDIT_FETCHING:
      return {
        ...state,
        auditListState: APP_STATE.FETCHING,
      }

    case AUDIT_DONE:
      return {
        ...state,
        auditListState: APP_STATE.DONE,
        auditList: action.auditList,
        pageTotal: action.pageTotal,
        page: action.page,
      }

    case AUDIT_FAILED:
      return {
        ...state,
        auditListState: APP_STATE.ERROR,
        auditList: [],
        fetchError: action.message,
        pageTotal: null,
        page: null,
      }

    // Audit modals
    case AUDIT_MODAL_REGIONS_FETCHING:
      return {
        ...state,
        auditModalRegionsState: APP_STATE.FETCHING,
      }

    case AUDIT_MODAL_REGIONS_DONE:
      return {
        ...state,
        auditModalRegionsState: APP_STATE.DONE,
        auditModalRegionsData: action.regionList,
      }

    case AUDIT_MODAL_REGIONS_FAILED:
      return {
        ...state,
        auditModalRegionsState: APP_STATE.ERROR,
        auditModalRegionsData: [],
        auditModalRegionsError: action.message,
      }

    case AUDIT_MODAL_RULES_FETCHING:
      return {
        ...state,
        auditModalRulesState: APP_STATE.FETCHING,
      }

    case AUDIT_MODAL_RULES_DONE:
      return {
        ...state,
        auditModalRulesState: APP_STATE.DONE,
        auditModalRulesData: action.ruleList,
      }

    case AUDIT_MODAL_RULES_FAILED:
      return {
        ...state,
        auditModalRulesState: APP_STATE.ERROR,
        auditModalRulesData: [],
        auditModalRulesError: action.message,
      }

    case AUDIT_MODAL_PARTNERS_FETCHING:
      return {
        ...state,
        auditModalPartnersState: APP_STATE.FETCHING,
      }

    case AUDIT_MODAL_PARTNERS_DONE:
      return {
        ...state,
        auditModalPartnersState: APP_STATE.DONE,
        auditModalPartnersData: action.partnerList,
      }

    case AUDIT_MODAL_PARTNERS_FAILED:
      return {
        ...state,
        auditModalPartnersState: APP_STATE.ERROR,
        auditModalPartnersData: [],
        auditModalPartnersError: action.message,
      }

    case AUDIT_MODAL_RULESETS_FETCHING:
      return {
        ...state,
        auditModalRulesetsState: APP_STATE.FETCHING,
      }

    case AUDIT_MODAL_RULESETS_DONE:
      return {
        ...state,
        auditModalRulesetsState: APP_STATE.DONE,
        auditModalRulesetsData: action.rulesetList,
      }

    case AUDIT_MODAL_RULESETS_FAILED:
      return {
        ...state,
        auditModalRulesetsState: APP_STATE.ERROR,
        auditModalRulesetsData: [],
        auditModalRulesetsError: action.message,
      }

    case RULESET_CREATION_SENDING:
      return {
        ...state,
        rulesetCreationState: APP_STATE.FETCHING,
      }

    case RULESET_CREATION_SUCCESS:
      return {
        ...state,
        rulesetCreationState: APP_STATE.DONE,
        rulesetCreationResponse: action.response,
      }

    case RULESET_CREATION_FAILED:
      return {
        ...state,
        rulesetCreationState: APP_STATE.ERROR,
        rulesetCreationResponse: action.response,
      }

    case RULESET_CREATION_RESET:
      return {
        ...state,
        rulesetCreationState: null,
        rulesetCreationResponse: null,
      }

    case AUDIT_FILE_SENDING:
      return {
        ...state,
        auditFileState: APP_STATE.FETCHING,
      }

    case AUDIT_FILE_SUCCESS:
      return {
        ...state,
        auditFileState: APP_STATE.DONE,
      }

    case AUDIT_FILE_FAILED:
      return {
        ...state,
        auditFileState: APP_STATE.ERROR,
      }

    case AUDIT_FILE_RESET:
      return {
        ...state,
        auditFileState: null,
      }

    case AUDIT_AMENDMENT_MODAL_RULES_FETCHING:
      return {
        ...state,
        auditModalAmendmentRulesState: APP_STATE.FETCHING,
      }

    case AUDIT_AMENDMENT_MODAL_RULES_DONE:
      return {
        ...state,
        auditModalAmendmentRulesState: APP_STATE.DONE,
        auditModalAmendmentRulesData: action.ruleList,
      }

    case AUDIT_AMENDMENT_MODAL_RULES_FAILED:
      return {
        ...state,
        auditModalAmendmentRulesState: APP_STATE.ERROR,
        auditModalAmendmentRulesData: [],
        auditModalAmendmentRulesError: action.message,
      }

    case AUDIT_RULE_AMENDMENT_SENDING:
      return {
        ...state,
        auditRuleAmendmentState: APP_STATE.FETCHING,
      }

    case AUDIT_RULE_AMENDMENT_SUCCESS:
      return {
        ...state,
        auditRuleAmendmentState: APP_STATE.DONE,
        auditRuleAmendmentResponse: null,
      }

    case AUDIT_RULE_AMENDMENT_FAILED:
      return {
        ...state,
        auditRuleAmendmentState: APP_STATE.ERROR,
        auditRuleAmendmentResponse: action.response,
      }

    case AUDIT_RULE_AMENDMENT_RESET:
      return {
        ...state,
        auditRuleAmendmentState: null,
        auditRuleAmendmentResponse: null,
      }

    default:
      return state
  }
}
